import { CardInfoWithId, CardModel, CardShift, PileCardModel } from "../../interface/game";
import { PileSetup } from "./pile-setup";

export function allFaceDownSetup(size: number): PileSetup {
    return (deck: CardInfoWithId[], gameCards: {[key: string]: CardModel}): PileCardModel[] => {
        const pileCards: PileCardModel[] = [];
        const count = size === -1 ? deck.length : Math.min(deck.length, size);
        for (let i=0; i<count; i++) {
            const cardId = deck.pop()?.id ?? '';
            pileCards.push({ id: cardId, draggable: false });
            gameCards[cardId] = {...gameCards[cardId], faceUp: false, shift: CardShift.CLOSED};
        }
        return pileCards;
    }
}